<template>
    <div class="no-data-container">
        <span v-if="textNoData" class="no-data-text">
            {{ $t(textNoData) }}
        </span>
        <span v-else class="no-data-text">
            {{ $t('widget.noData') }}
        </span>
    </div>
</template>

<script>
import { defineComponent } from 'vue';

export default defineComponent({
    name: 'NoDataWidget',
    props: {
        textNoData: { type: String, required: false },
    },
});
</script>

<style scoped>
.no-data-container {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    flex: 1;
}
.no-data-text {
    font-size: 20px;
    font-weight: 200;
}
</style>
